// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__D-Bh1","content":"NotFoundPage_content__rf2L+","title":"NotFoundPage_title__4G8FX"};